import React from "react";
import Icon from "@mdi/react";
import { mdiArrowDown, mdiArrowUp } from "@mdi/js";

export interface ShowThresholdIconProps {
  isLessThan: boolean;
}

const ShowThresholdIcon: React.FC<ShowThresholdIconProps> = ({
  isLessThan,
}) => {
  return (
    <React.Fragment>
      <Icon
        path={isLessThan ? mdiArrowDown : mdiArrowUp}
        size={0.5}
        color="#D62828"
        style={{ marginBottom: -1 }}
      />
    </React.Fragment>
  );
};

export default ShowThresholdIcon;
